import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FiUser, FiMenu, FiX } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-hot-toast";
import "./navbarDash.scss";
import { useSendLogoutMutation } from "../../features/api/authApiSlice";
import { useGetMeQuery } from "../../features/api/userApiSlice";
import { selectCurrentToken } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";
import AdminAlertsBadge from "../admin/alerts/AlertBadge";

const NavbarDash = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const token = useSelector(selectCurrentToken);
  const [sendLogout] = useSendLogoutMutation();

  const { data: user } = useGetMeQuery(undefined, {
    skip: !token,
  });

  const handleLogout = async () => {
    try {
      await sendLogout();
      localStorage.removeItem("accessToken");
      //toast.success(response?.data?.message);
    } catch (error) {
      return toast.error(error?.data?.message);
    }
  };

  // 🔹 Links differ for User vs Admin
  const userLinks = [
    { to: "/dashboard", label: "Dashboard" },
    { to: "/dashboard/bookings", label: "My Bookings" },
    { to: "/dashboard/payments", label: "Payments" },
    { to: "/dashboard/settings", label: "Settings" },
  ];

  const adminLinks = [
    { to: "/admin", label: "Dashboard" },
    { to: "/admin/users", label: "Users" },
    { to: "/admin/videos", label: "Videos" },
    { to: "/admin/products", label: "Products" },
    { to: "/admin/invite", label: "Invite Admin" },
  ];

  const navLinks = user?.roles?.includes("Admin") ? adminLinks : userLinks;

  return (
    <nav className="dash-navbar">
      {/* Logo / Title */}
      <div className="dash-navbar__logo">
        <div className="navbar__logo">
          <Link to="/">
            <img
              src="https://woodsmithstorecontent.s3.us-east-2.amazonaws.com/logo/enotes_logo.png"
              alt="Twiga web design logo"
            />
          </Link>
        </div>
      </div>

      {/* Desktop Nav */}
      <ul className="dash-navbar__links">
        {navLinks.map((link) => (
          <li key={link.to}>
            <NavLink
              to={link.to}
              end
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>

      {/* Right side actions */}
      <div className="dash-navbar__actions">
        <div className="nav_right_buttons">
          <AdminAlertsBadge />
        </div>

        {/* Profile Dropdown */}
        <div className="user-menu">
          <button
            className="user-btn"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <FiUser /> <span>{user?.firstName}</span>
          </button>

          <AnimatePresence>
            {menuOpen && (
              <motion.ul
                className="dropdown"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
              >
                <li className="dropdown__header">{user?.firstName}</li>
                <li>
                  <NavLink to="/profile">My Profile</NavLink>
                </li>
                <li>
                  <button className="logout-btn" onClick={handleLogout}>
                    Logout
                  </button>
                </li>
              </motion.ul>
            )}
          </AnimatePresence>
        </div>

        {/* Hamburger (mobile) */}
        <button
          className="hamburger"
          onClick={() => setMobileOpen((prev) => !prev)}
        >
          {mobileOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3 }}
          >
            <ul>
              {navLinks.map((link) => (
                <li key={link.to}>
                  <NavLink to={link.to} onClick={() => setMobileOpen(false)}>
                    {link.label}
                  </NavLink>
                </li>
              ))}
              <hr />
              <li className="mobile-user">{user?.name}</li>
              <li>
                <NavLink
                  to="/dashboard/profile"
                  onClick={() => setMobileOpen(false)}
                >
                  My Profile
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/dashboard/settings"
                  onClick={() => setMobileOpen(false)}
                >
                  Settings
                </NavLink>
              </li>
              <li>
                <button className="logout-btn" onClick={handleLogout}>
                  Logout
                </button>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default NavbarDash;
